import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { TasksService } from "../../features/tasks/services/tasks.service";

@Component({
    selector: 'add-items-dialog',
    templateUrl: './add-items-dialog.html',
    styleUrls: ['./quotation-new.component.scss'],
    standalone: true,
    imports: [
      MatDialogModule,
      MatButtonModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      ReactiveFormsModule,
      MatOptionModule,
      CommonModule,
    ],
  })
  export class AddItemsDialog {
    showFirstField: boolean = true;
    itemData: any;
    taskVariants: any;
    itemGroup: FormGroup;
    selectedItem: string = '';
    formGroup!: FormGroup;
    allItems: any[];
    taskItems: any[] = [];
  serviceTaskId: any;
  
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialogRef: MatDialogRef<AddItemsDialog>,
      private fb: FormBuilder,
      private taskService: TasksService,
    ) {
      this.allItems = [];
      console.log(data);
  
      this.itemGroup = this.fb.group({
        variants: this.fb.array([])  // FormArray of task variant groups
      });
    }
  
    ngOnInit(): void {
        const id = this.data?.serviceId;
        if(id){
            this.findAllServiceTasksOfAService(id);
        }
    }
  
    get variants(): FormArray {
      return this.itemGroup.get('variants') as FormArray;
    }
   
    findAllServiceTasksOfAService(id: number): void {
      this.taskService.findAllServiceTasksOfAService(id).subscribe({
        next: (data) => {
          const tasks = data || [];
          this.taskItems = tasks;
          this.variants.clear();  // Clear previous form rows if any
    
          tasks.forEach((taskObj: any) => {
            const taskData = taskObj?.taskData || []; 
            this.addTaskVariant(taskData, taskObj);
          });
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
    

    addTaskVariant(taskData?: any, taskObj?: any) {
      const taskGroup = this.fb.group({
        serviceTaskId: taskObj?.id || null,
        taskName: [taskData?.taskName || null],
        taskVariantId: ['', Validators.required],
        price: [0, Validators.required],
        eta: ['', Validators.required],
        variants: [taskData?.taskVariants || []]  // store per-row dropdown options
      });
    
      if(taskData?.taskVariants?.length > 0){
        this.variants.push(taskGroup);
      }
    }
    

    onVariantSelected(index: number) {
      const group = this.variants.at(index) as FormGroup;
      const variantId = group.get('taskVariantId')?.value;
      const variantList = group.get('variants')?.value || [];
    
      const selectedVariant = variantList.find((v: any) => v.id === variantId);
    
      if (selectedVariant) {
        group.patchValue({
          price: selectedVariant.price,
          eta: selectedVariant.estimatedTime
        });
      }
    }

    onSubmit(): void {
      if (this.itemGroup.valid) {
        const submittedData = this.itemGroup.value.variants;
    
        const transformed = submittedData.map((item: any) => {
          const selectedVariant = item.variants.find((v: any) => v.id === item.taskVariantId);
    
          return {
            taskName: item.taskName,
            taskVariantId: item.taskVariantId,
            price: item.price,
            eta: item.eta,
            serviceTaskId: item.serviceTaskId,
            variant: selectedVariant || null  // Fallback in case variant not found
          };
        });
    
        console.log('Transformed:', transformed);
        this.dialogRef.close(transformed);
      } else {
        this.itemGroup.markAllAsTouched();
      }
    }
    
   
    onCancel(): void {
      this.dialogRef.close();
    }
    preventEnterKey(event: KeyboardEvent): void {
      if (event.key === 'Enter') {
        event.preventDefault();
        console.log('Enter key press prevented.');
      }
    }
  }